import { render, staticRenderFns } from "./PerformanceRedemptionOverview.vue?vue&type=template&id=6b69d2b6&scoped=true&"
import script from "./PerformanceRedemptionOverview.vue?vue&type=script&lang=ts&"
export * from "./PerformanceRedemptionOverview.vue?vue&type=script&lang=ts&"
import style0 from "./PerformanceRedemptionOverview.vue?vue&type=style&index=0&id=6b69d2b6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b69d2b6",
  null
  
)

export default component.exports